import axios from "axios";
import Cookies from "js-cookie";

export const getChargeableCallsPerService = async (params) => {
  await axios
    .post("/api/v1/metrics/chargeable_calls_per_service", params, {
      headers: {
        Authorization: `Bearer ${
          Cookies.get("jwt") || localStorage.getItem("jwt")
        }`,
      },
    })
    .catch((error) => {
      throw error;
    });
};

export const getChargeableCalls = async (params) => {
  await axios
    .post("/api/v1/metrics/chargeable_calls", params, {
      headers: {
        Authorization: `Bearer ${
          Cookies.get("jwt") || localStorage.getItem("jwt")
        }`,
      },
    })
    .catch((error) => {
      throw error;
    });
};

export const getTotalCallsPerService = async (params) => {
  await axios
    .post("/api/v1/metrics/total_api_calls_per_service", params, {
      headers: {
        Authorization: `Bearer ${
          Cookies.get("jwt") || localStorage.getItem("jwt")
        }`,
      },
    })
    .catch((error) => {
      throw error;
    });
};

export const getTotalCalls = async (params) => {
  await axios
    .post("/api/v1/metrics/total_api_calls", params, {
      headers: {
        Authorization: `Bearer ${
          Cookies.get("jwt") || localStorage.getItem("jwt")
        }`,
      },
    })
    .catch((error) => {
      throw error;
    });
};

export const getTotalSuccessRate = async (params) => {
  await axios
    .post("/api/v1/metrics/total_success_rate", params, {
      headers: {
        Authorization: `Bearer ${
          Cookies.get("jwt") || localStorage.getItem("jwt")
        }`,
      },
    })
    .catch((error) => {
      throw error;
    });
};

export const getTotalScoredUsers = async (params) => {
  await axios
    .post("/api/v1/metrics/total_scored_users", params, {
      headers: {
        Authorization: `Bearer ${
          Cookies.get("jwt") || localStorage.getItem("jwt")
        }`,
      },
    })
    .catch((error) => {
      throw error;
    });
};

export const getSuccessRatePerService = async (params) => {
  await axios
    .post("/api/v1/metrics/success_rate_per_service", params, {
      headers: {
        Authorization: `Bearer ${
          Cookies.get("jwt") || localStorage.getItem("jwt")
        }`,
      },
    })
    .catch((error) => {
      throw error;
    });
};

export const getTotalSuccessRatePerApp = async (params) => {
  await axios
    .post("/api/v1/metrics/total_success_rate_per_app", params, {
      headers: {
        Authorization: `Bearer ${
          Cookies.get("jwt") || localStorage.getItem("jwt")
        }`,
      },
    })
    .catch((error) => {
      throw error;
    });
};

export const getMonthlyTotalCallsPerService = async (params) => {
  await axios
    .post("/api/v1/metrics/monthly_total_calls_per_service", params, {
      headers: {
        Authorization: `Bearer ${
          Cookies.get("jwt") || localStorage.getItem("jwt")
        }`,
      },
    })
    .catch((error) => {
      throw error;
    });
};

export const getMonthlyTotalCalls = async (params) => {
  await axios
    .post("/api/v1/metrics/monthly_total_calls", params, {
      headers: {
        Authorization: `Bearer ${
          Cookies.get("jwt") || localStorage.getItem("jwt")
        }`,
      },
    })
    .catch((error) => {
      throw error;
    });
};

export const getMonthlyScoredUsers = async (params) => {
  await axios
    .post("/api/v1/metrics/monthly_scored_users", params, {
      headers: {
        Authorization: `Bearer ${
          Cookies.get("jwt") || localStorage.getItem("jwt")
        }`,
      },
    })
    .catch((error) => {
      throw error;
    });
};

export const getMonthlyChargeableCalls = async (params) => {
  await axios
    .post("/api/v1/metrics/monthly_chargeable_calls", params, {
      headers: {
        Authorization: `Bearer ${
          Cookies.get("jwt") || localStorage.getItem("jwt")
        }`,
      },
    })
    .catch((error) => {
      throw error;
    });
};

export const getFinscoreTotalUploads = async () => {
  const response = await axios
    .get("/api/v1/metrics/finscore_file_total_uploads", {
      headers: {
        Authorization: `Bearer ${
          Cookies.get("jwt") || localStorage.getItem("jwt")
        }`,
      },
    })
    .catch((error) => {
      throw error;
    });
  if (response.status === 200) {
    return response.data;
  }
};

export const getFincludeTotalApps = async () => {
  const response = await axios
    .get("/api/v1/metrics/finclude_total_apps", {
      headers: {
        Authorization: `Bearer ${
          Cookies.get("jwt") || localStorage.getItem("jwt")
        }`,
      },
    })
    .catch((error) => {
      throw error;
    });
  if (response.status === 200) {
    return response.data;
  }
};

export const getFinstreamTotalApps = async () => {
  const response = await axios
    .get("/api/v1/metrics/finstream_total_apps", {
      headers: {
        Authorization: `Bearer ${
          Cookies.get("jwt") || localStorage.getItem("jwt")
        }`,
      },
    })
    .catch((error) => {
      throw error;
    });
  if (response.status === 200) {
    return response.data;
  }
};

export const getFinstreamTotalUploads = async () => {
  const response = await axios
    .get("/api/v1/metrics/finscore_file_total_uploads", {
      headers: {
        Authorization: `Bearer ${
          Cookies.get("jwt") || localStorage.getItem("jwt")
        }`,
      },
    })
    .catch((error) => {
      throw error;
    });
  if (response.status === 200) {
    return response.data;
  }
};
